import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { SingleProjectToTargetComponentBase } from 'common-ui';

@Component({
  selector: 'ideal-render-target-item-result-info',
  standalone: true,
  imports: [],
  template: ``,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: 0.25em;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemResultInfoRenderTargetComponent extends SingleProjectToTargetComponentBase {
  public override readonly context = undefined;
  protected readonly renderInElements = computed(() => this.renderNodes().map((node) => this.element));
}
